import React from 'react'
import './styles.css' // Import the CSS file for styling
import FixWidthContainer from '../../atoms/fixWidthContainer'
import Spacer from '../../atoms/Spacer'
import CommonButton from '../../atoms/CommonButton'
import InfoItem from '../../atoms/InfoItem'
import BabyChangingStationIcon from '@mui/icons-material/BabyChangingStation'
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import PhoneIcon from '@mui/icons-material/Phone'
import DescriptionIcon from '@mui/icons-material/Description'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom'
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder'
import BedroomBabyIcon from '@mui/icons-material/BedroomBaby'

const Infos = () => {
  return (
    <div>
      <FixWidthContainer>
        <Spacer size={60} />
        <CommonButton
          alignSelf={'center'}
          backgroundColor={'transparent'}
          color="#E79A89"
        >
          Informações sobre as consultas
        </CommonButton>
        <Spacer size={60} />
        <div className="infos-container">
          <InfoItem
            icon={
              <HourglassBottomIcon
                style={{
                  color: 'white',
                  backgroundColor: '#E79A89',
                  borderRadius: '100%',
                }}
              />
            }
            text="Consultas e retornos com duração individualizada"
          />
          <InfoItem
            icon={
              <LocalHospitalIcon
                style={{
                  color: 'white',
                  backgroundColor: '#E79A89',
                  borderRadius: '100%',
                }}
              />
            }
            text="Disponibilidade para atendimento de demandas urgentes"
          />
          {/* <InfoItem
            icon={
              <BabyChangingStationIcon
                style={{
                  color: 'white',
                  backgroundColor: '#E79A89',
                  borderRadius: '100%',
                }}
              />
            }
            text="Disponibilidade para contato após consultas"
          /> */}
          <InfoItem
            icon={
              <PhoneIcon
                style={{
                  color: 'white',
                  backgroundColor: '#E79A89',
                  borderRadius: '100%',
                }}
              />
            }
            text="Disponibilidade para contato após consultas"
          />
          <InfoItem
            icon={
              <DescriptionIcon
                style={{
                  color: 'white',
                  backgroundColor: '#E79A89',
                  borderRadius: '100%',
                }}
              />
            }
            text="Consultas particulares com emissão de nota-fiscal"
          />
          <InfoItem
            icon={
              <DirectionsCarIcon
                style={{
                  color: 'white',
                  backgroundColor: '#E79A89',
                  borderRadius: '100%',
                }}
              />
            }
            text="Localização central com facilidade de estacionamento"
          />
          <InfoItem
            icon={
              <FamilyRestroomIcon
                style={{
                  color: 'white',
                  backgroundColor: '#E79A89',
                  borderRadius: '100%',
                }}
              />
            }
            text="Sala de espera ampla e agradável"
          />
          <InfoItem
            icon={
              <QueryBuilderIcon
                style={{
                  color: 'white',
                  backgroundColor: '#E79A89',
                  borderRadius: '100%',
                }}
              />
            }
            text="Valorização da pontualidade"
          />
          <InfoItem
            icon={
              <BedroomBabyIcon
                style={{
                  color: 'white',
                  backgroundColor: '#E79A89',
                  borderRadius: '100%',
                }}
              />
            }
            text="Consultório lúdico e espaçoso"
          />
        </div>
      </FixWidthContainer>
    </div>
  )
}

export default Infos
